import React from "react"
import { useSortBy } from 'react-instantsearch';

function Sort({ category, items, onChange   }){
var defaultRefinement = 'products';
if(category?.applicationCategory)
{
	defaultRefinement = 'products_alphabetical_asc';
}
 const { options, currentRefinement, refine } = useSortBy({
    items: [
		{
			value: "products_alphabetical_asc",
			label: "Alphabetically: A-Z",
		},
		{
			value: "products_newest_desc",
			label: "Newest",
		},
	],
    defaultRefinement: defaultRefinement,
  });
 // console.log(category)
 // console.log(defaultRefinement)
   return (<select    onChange={(event) => refine(event.target.value)}  value={currentRefinement} >
        <option value="products" >Sort by</option>
        {options.map(item => (
            <option
                key={item.value}
                value={item.value}
            >
                {item.label}
            </option>
        ))}
    </select>)
}
export default Sort